import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import * as Common from 'common/components';

class AssetsEditView extends PureComponent {
  static propTypes = {
    children: PropTypes.element.isRequired,
    company: PropTypes.object.isRequired,
    subcompany: PropTypes.object.isRequired,
    asset: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
  };

  render = () => {
    const { asset } = this.props;
    let indexInteger = '';
    if (asset.indexInteger && asset.indexInteger[0] && asset.indexInteger[0].indexString) {
      indexInteger = asset.indexInteger[0].indexString;
    }
    return (
      <Common.Wrapper fluid={true}>
        <Common.Header title={this.props.t('assets.title')} />
        <div className="col-12">
          <Common.Portlet
            title={this.props.t('assets.edit')}
            subtitle={
              (this.props.asset && `${asset.number} - ${asset.name} - ${indexInteger}`) || ''
            }
            icon={'qrcode'}
          >
            {this.props.children}
          </Common.Portlet>
        </div>
      </Common.Wrapper>
    );
  };
}

export default translate()(AssetsEditView);



// WEBPACK FOOTER //
// src/components/assets/edit/AssetsEditWrapper.js